import request from '@/plugin/axios'


export function listPage(param){
    return request({
        url:"/api/admin/sysEnterprise/pageList",
        method:'post',
        data:param
    })
}
export function govList(param){
    return request({
        url:"/api/admin/sysEnterprise/govList",
        method:'post',
        data:param
    })
}
export function signList(query){
    return request({
        url: '/api/admin/sysEnterprise/signList',
        method: 'get',
        params: query
    })
}

export function queryStatus(query){
    return request({
        url: '/api/admin/sysEnterprise/status',
        method: 'get',
        params: query
    })
}


export function addObj(obj) {
    return request({
        url: '/api/admin/sysEnterprise/add',
        method: 'post',
        data: obj
    })
}

/**
 * 上传文件
 * @returns {*}
 */
export function uploadFile(params) {
    return request({
        url: '/api/admin/sysFiles/uploadContractEnclosure',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data: params
    });
}

export function openEnterprise(obj){
    return request({
        url: '/api/admin/sysEnterprise/open',
        method: 'post',
        data: obj
    })
}


export function selectBaseTown(param){
    return request({
        url:"/api/admin/town/selectList",
        method:'get',
        params:param
    })
}

export function againOpen(obj){
    return request({
        url: '/api/admin/sysEnterpriseOpen/againOpen',
        method: 'post',
        data: obj
    })
}

export function getObj(id) {
    return request({
        url: '/api/admin/sysEnterprise/' + id,
        method: 'get'
    })
}

export function delObj(id) {
    return request({
        url: '/api/admin/sysEnterprise/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/api/admin/sysEnterprise/update',
        method: 'put',
        data: obj
    })
}

export function enterpriseAll(param){
    return request({
        url:"/api/admin/sysEnterprise/entList",
        method:'get',
        params:param
    })
}

export function enterpriseDetail(param){
    return request({
        url:"/api/admin/sysEnterprise/enterpriseDetail",
        method:'get',
        params:param
    })
}

export function rejectOpenDetail(param){
    return request({
        url:"/api/admin/sysEnterpriseOpen/rejectOpenDetail",
        method:'get',
        params:param
    })
}
export function findEntReportView(param){
    return request({
        url:"/api/admin/sysEnterprise/findEntReportView",
        method:'get',
        params:param
    })
}

export function findEntOilRanking(param){
    return request({
        url:"/api/admin/sysEnterprise/findEntOilRanking",
        method:'get',
        params:param
    })
}

export function findTruckoilRealTime(param){
    return request({
        url:"/api/admin/sysEnterprise/findTruckoilRealTime",
        method:'get',
        params:param
    })
}
export function findTimeNoOilReport(param){
    return request({
        url:"/api/admin/sysEnterprise/findTimeNoOilReport",
        method:'get',
        params:param
    })
}
export function findOilEdequipmentGeoList(param){
    return request({
        url:"/api/admin/sysEnterprise/findOilEdequipmentGeoList",
        method:'get',
        params:param
    })
}

export function findYearMonthReport(param){
    return request({
        url:"/api/admin/sysEnterprise/queryYearMonthReport",
        method:'get',
        params:param
    })
}

export function pullList(params){
    return request({
        url:"/api/admin/sysEnterprise/pullList",
        method:'post',
        data: params
    })
}